import { useState } from "react";
import useCreate from "../../hooks/useCreate";
import toast from "react-hot-toast";

function useBlogSlug({ blog_id, initialSlug, onSuccess }) {
  const [openSlugModal, setOpenSlugModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [slug, setSlug] = useState(initialSlug || "");

  const { setDataToServer } = useCreate({
    url: "update-blog-slug",
    refreshUrl: "get-blog-list",
    onSuccess: () => {
      toast.success("Slug Updated Successfully", {
        position: "top-right",
        duration: 3000,
      });
      handleCloseSlugModal();
      onSuccess?.(slug);
    },
    onError: (err) => {
      const { status, data } = err.response || {};
      if (status === 400) {
        toast.error(data?.message || "Invalid slug", {
          position: "top-right",
          duration: 3000,
        });
      } else {
        toast.error("Something went wrong please try again later", {
          position: "top-right",
          duration: 3000,
        });
      }
    },
  });

  function sanitizeSlug(text) {
    return text.replace(/[^a-zA-Z0-9\-]/g, "");
  }
  
  const handleSlugChange = (e) => {
    let val = e.target.value;
    val = val.replace(/\s+/g, "-").toLowerCase();
    let sanitizedSlug = sanitizeSlug(val);
    setSlug(sanitizedSlug);
  };

  const handleOpenSlug = () => {
    setSlug(initialSlug);
    setOpenSlugModal(true);
  };

  const handleCloseSlugModal = () => {
    setOpenSlugModal(false);
    setIsOpen(false);
  };
  
  const toggleButton = () => {
    setIsOpen(!isOpen);
  };

  const handleSubmitSlug = (e) => {
    e.preventDefault();
    setDataToServer.mutate({
      blog_id,
      slug,
    });
  };

  return {
    slug,
    openSlugModal,
    isOpen,
    isSubmitting: setDataToServer.isLoading,
    handleSlugChange,
    handleOpenSlug,
    handleCloseSlugModal,
    toggleButton,
    handleSubmitSlug,
  };
}

export default useBlogSlug;
